/**
 * `futurex skills [list | <request>]` — list the available skills, or show which
 * skills a request routes to (the deterministic intent → skill composer).
 */
import { buildRepoCard, findRepoRoot } from './repo.js';
import { BUILTIN_SKILLS, selectSkills } from './skills.js';
import { color, info, line } from './ui.js';

export function runSkills(arg: string): void {
  const q = arg.trim();
  if (q === '' || q === 'list') {
    const card = buildRepoCard(findRepoRoot());
    const stack = [card.framework, card.backend].filter((x): x is string => Boolean(x));
    info(`skills (${BUILTIN_SKILLS.length})${stack.length ? ` · detected stack: ${stack.join(', ')}` : ''}:`);
    for (const s of BUILTIN_SKILLS) {
      line(`  ${color.cyan(s.name)} — ${s.description} ${color.dim(`[${s.modelHint}]`)}`);
      line(color.dim(`      triggers: ${s.triggers.slice(0, 6).join(', ')}`));
    }
    line(color.dim('route a request: `futurex skills "build a chat app in Next.js"`'));
    return;
  }
  const matched = selectSkills(q);
  info(`"${q}" → ${matched.length} skill${matched.length === 1 ? '' : 's'}:`);
  for (const s of matched) {
    line(`  ${color.cyan(s.name)} ${color.dim(`[${s.modelHint}]`)} — ${s.description}`);
  }
}
